import Vue from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import App from './App.vue';

Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init({
      delay: 200,
      duration: 750,
      once: true,
    });
  },
  render: (h) => h(App),
}).$mount('#app');
